import React from 'react'
import { Link } from 'react-router-dom'
import qRaptorLogo from '../../assets/qraptor-logo.png'
import { BackgroundGradient } from '../ui/BackgroundGradient'

// -- Checkmark bullet icon --
function BulletIcon({ color }) {
  return (
    <svg className="bullet-icon" width="13" height="13" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M2 7l3.5 3.5L12 3" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

// -- AI Neural-network icon for Service panel --
function ServiceAIIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      {/* Central node */}
      <circle cx="12" cy="12" r="2.2" fill="#06B6D4" />
      {/* Outer nodes */}
      <circle cx="12" cy="4"  r="1.4" fill="#06B6D4" opacity="0.7"/>
      <circle cx="20" cy="9"  r="1.4" fill="#06B6D4" opacity="0.7"/>
      <circle cx="20" cy="15" r="1.4" fill="#06B6D4" opacity="0.7"/>
      <circle cx="12" cy="20" r="1.4" fill="#06B6D4" opacity="0.7"/>
      <circle cx="4"  cy="15" r="1.4" fill="#06B6D4" opacity="0.7"/>
      <circle cx="4"  cy="9"  r="1.4" fill="#06B6D4" opacity="0.7"/>
      {/* Connections */}
      <line x1="12" y1="12" x2="12" y2="5.4"  stroke="#06B6D4" strokeWidth="1" opacity="0.45"/>
      <line x1="12" y1="12" x2="18.7" y2="9.7" stroke="#06B6D4" strokeWidth="1" opacity="0.45"/>
      <line x1="12" y1="12" x2="18.7" y2="14.3"stroke="#06B6D4" strokeWidth="1" opacity="0.45"/>
      <line x1="12" y1="12" x2="12" y2="18.6"  stroke="#06B6D4" strokeWidth="1" opacity="0.45"/>
      <line x1="12" y1="12" x2="5.3" y2="14.3" stroke="#06B6D4" strokeWidth="1" opacity="0.45"/>
      <line x1="12" y1="12" x2="5.3" y2="9.7"  stroke="#06B6D4" strokeWidth="1" opacity="0.45"/>
    </svg>
  )
}

// -- OfferingSection --
export default function OfferingSection() {
  return (
    <section className="section section-offering" id="platform" aria-label="Core Offerings">
      {/* Parallax glow blobs — clipped by section overflow:hidden */}
      <div className="parallax-blob parallax-blob-purple-down" style={{ width: 520, height: 520, top: '-15%', right: '-10%' }} aria-hidden="true" />
      <div className="container">

        {/* Centered heading */}
        <div className="offering-section-header" data-animate="fade-up">
          <h2 className="offering-heading-large">
            Enabling the Shift to AI-Native Enterprises
          </h2>
        </div>

        {/* Two-panel layout */}
        <div className="offering-two-panel" data-animate="fade-up" data-delay="100">

          {/* LEFT — boxed card container (Product) */}
          <BackgroundGradient>
            <article className="offering-card offering-card--indigo" aria-label="qRaptor AI-Native Platform">
            <div className="card-inner">
              <div className="card-icon-wrap card-icon-logo" aria-hidden="true">
                <img src={qRaptorLogo} alt="qRaptor" className="card-icon-img" />
              </div>
              <div className="card-tag">Product</div>
              <h3 className="card-title">qRaptor AI-Native Platform</h3>
              <p className="card-desc">
                Our flagship platform, qRaptor.ai, is purpose-built for organizations that need
                to design, deploy, and operate full-stack intelligent AI applications at production scale.
              </p>
              <ul className="card-bullets" role="list">
                {[
                  'Full-stack AI application development',
                  'Enterprise-grade governance & observability',
                  'Production-ready deployment infrastructure',
                ].map((b) => (
                  <li key={b} className="bullet-item">
                    <BulletIcon color="#7C3AED" />
                    {b}
                  </li>
                ))}
              </ul>
              <div className="card-footer">
                <a
                  href="https://qraptor.ai/"
                  className="card-cta-pill"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Know more
                  <svg width="13" height="13" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                    <path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </div>
            </div>
          </article>
          </BackgroundGradient>

          {/* RIGHT — plain panel, hover reveals container (Service) */}
          <Link to="/transform" className="offering-panel--plain" aria-label="AI-Native Transformation">
            <div className="card-icon-wrap card-icon-teal" aria-hidden="true">
              <ServiceAIIcon />
            </div>
            <div className="card-tag">Service</div>
            <h3 className="card-title">AI-Native Transformation</h3>
            <p className="card-desc">
              Transformation programs that help businesses redesign architectures, workflows,
              and operational models for AI-native execution.
            </p>
            <ul className="card-bullets" role="list">
              {[
                'Architecture modernization & system redesign',
                'Workflow redesign for agentic operations',
                'Intelligent system adoption & change enablement',
              ].map((b) => (
                <li key={b} className="bullet-item">
                  <BulletIcon color="#06B6D4" />
                  {b}
                </li>
              ))}
            </ul>
            <div className="plain-panel-footer">
              <span className="card-cta-pill card-cta-pill--teal">
                Know more
                <svg width="13" height="13" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                  <path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            </div>
          </Link>

        </div>
      </div>
    </section>
  )
}